import {
  BusinessCustomer,
  PrivateCustomer,
  constants,
  ERPPaymentType,
} from '@oresundsbron/validators';

export const isDashboardEntry = <T extends { key: string }>(entry: T) =>
  entry.key === 'dashboard';

export interface CustomerStatus {
  backgroundColor: string;
  translationKey: string;
}

export interface ProviderInfo {
  issuer: string;
  link: string;
}

export const getCustomerStatus = (
  customer?: PrivateCustomer | BusinessCustomer
): CustomerStatus | undefined => {
  if (!customer) {
    return undefined;
  }

  switch (customer.status) {
    case constants.customerStatus.inactive:
      return {
        backgroundColor: 'bg-red-300',
        translationKey: 'dashboard.inactive',
      };
    case constants.customerStatus.pending:
      return {
        backgroundColor: 'bg-yellow-200',
        translationKey: 'dashboard.pending',
      };
    case constants.customerStatus.pendingInvoice:
      return {
        backgroundColor: 'bg-yellow-200',
        translationKey: 'dashboard.pending_invoice',
      };
    case constants.customerStatus.cardExpired:
    case constants.customerStatus.blocked:
      return {
        backgroundColor: 'bg-red-300',
        translationKey: 'dashboard.blocked',
      };
    default:
      return undefined;
  }
};

export const getProviderInfo = (
  customer?: PrivateCustomer | BusinessCustomer
): ProviderInfo | undefined => {
  if (!customer || !customer.contracts || customer.contracts.length === 0) {
    return undefined;
  }

  switch (customer.contracts[0].paymentIssuer) {
    case ERPPaymentType.bbas:
      return {
        issuer: 'BroBizz',
        link: 'https://brobizz.eu.auth0.com/u/login?state=hKFo2SBSQU9nVUtzbzM2eUtVTnRnaWZhMGlQcE5CVC11YWZ0Q6Fur3VuaXZlcnNhbC1sb2dpbqN0aWTZIEhXWWNTR1pxWk4zX251WXlfWGlvZXdJMlI2dVhyMVExo2NpZNkgRDEzclBDRlM4bEFKWmNWWkJXdUtCUWRaeER3NDNKSjg',
      };
    case ERPPaymentType.fremtind:
      return {
        issuer: 'AutoSync',
        link: 'https://fremtindservice.no/logg-inn-informasjon/',
      };
    case ERPPaymentType.skyttelpass:
      return {
        issuer: 'SkyttelPass',
        link: 'https://minside.skyttelpass.no/',
      };
    case ERPPaymentType.tollTickets:
      return {
        issuer: 'Tollticket',
        link: 'https://tolltickets.com/en/',
      };
    case ERPPaymentType.flytpass:
      return {
        issuer: 'Flytpass',
        link: 'https://flytpass.no/minside',
      };
    case ERPPaymentType.dkv:
      return {
        issuer: 'DKV',
        link: 'https://my.dkv-mobility.com/auth/realms/dkv/protocol/openid-connect/auth?response_type=code&client_id=dkv-portal&state=SGtfdWVjeUxKSy1vVVNMbVZEZ3oyMTROWndQaFgwc3IxYX5PYVJONXR-b2pu&redirect_uri=https:%2f%2fmy.dkv-mobility.com%2fdkv-portal-webapp&scope=openid%20profile%20email&code_challenge=VYKU_2yoY0pMKg75i30PKqmluUkU1MCzCoLdm7NBeR4&code_challenge_method=S256&nonce=SGtfdWVjeUxKSy1vVVNMbVZEZ3oyMTROWndQaFgwc3IxYX5PYVJONXR-b2pu',
      };
    case ERPPaymentType.axxes:
      return {
        issuer: 'AXXES',
        link: 'https://axxes.fr/',
      };
    case ERPPaymentType.as24:
      return {
        issuer: 'AS24/Total',
        link: 'https://www.as24.com/',
      };
    case ERPPaymentType.eurowag:
      return {
        issuer: 'Eurowag',
        link: 'https://www.eurowag.com/',
      };
    case ERPPaymentType.toll4europe:
      return {
        issuer: 'Toll4Europe',
        link: 'https://toll4europe.eu/',
      };
    default:
      return undefined;
  }
};
